import { useState } from "react";
const WhatIsBizzTrip = (props) => {
  const [lang] = useState({
    tr: {
      title: "BIZZTRIP NEDİR?",
      paragraph: [
        "BizzTrip, genç yeteneklerin Unilever dünyasını tanıma fırsatı bulacağı tam günlük bir canlı yayın etkinliğidir. BizzTrip, genç yeteneklere benzersiz bir öğrenme deneyimi sunarken aynı zamanda kariyer yolculuklarını şekillendirerek akıllarındaki soru işaretlerine cevap bulma şansı da sunmaktadır.",
        "BizzTrip, 17 yıldır üniversite öğrencilerinin kariyerlerine yönelik ilk adımlarını atmadan önce işletme hakkında daha fazla bilgi edinmelerine yardımcı olan bir Unilever geleneği olmuştur.",
        "Üstelik BizzTrip, bu yıl Knorr Çabuk ev sahipliğinde gerçekleştirilerek lezzetli ve eğlenceli bir deneyim sunacak!",
      ],
    },
    eng: {
      title: "WHAT IS BIZZTRIP?",
      paragraph: [
        "BizzTrip is a full-day event where young talents will have the opportunity to get to know the world of Unilever. BizzTrip offers young talents the chance to find answers to the question marks in their minds in shaping their career journey while providing a unique learning experience.",
        "For 17 years, BizzTrip has been a Unilever tradition to help university students learn more about business before taking their first steps towards their careers.",
        "Bizztrip will offer a delicious and fun experience this year hosted by Knorr Çabuk!",
      ],
    },
  });

  return (
    <section
      id={props.currentLang === "eng" ? "what-is-bizztrip" : "bizztrip-nedir"}
      className="w-full pt-32 pb-6 flex justify-center"
    >
      <div data-aos="fade-up" className="w-4/5 max-w-screen-xl space-y-6">
        <div className="flex justify-center">
          <h4 className="text-yellow-custom font-bold text-4xl sm:text-5xl md:text-7xl text-center">
            {props.currentLang === "eng" ? lang.eng.title : lang.tr.title}
          </h4>
        </div>
        <div className="text-center px-0 md:px-5 2xl:px-16">
          <p className="text-white font-medium text-lg lg:text-2xl">
            {props.currentLang === "eng"
              ? lang.eng.paragraph[0]
              : lang.tr.paragraph[0]}
          </p>
          <br />
          <p className="text-white font-medium text-lg lg:text-2xl">
            {props.currentLang === "eng"
              ? lang.eng.paragraph[1]
              : lang.tr.paragraph[1]}
          </p>
          <br />
          <p className="text-white font-medium text-lg lg:text-2xl">
            {props.currentLang === "eng"
              ? lang.eng.paragraph[2]
              : lang.tr.paragraph[2]}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIsBizzTrip;
